import { render, staticRenderFns } from "./ChannelAdd.vue?vue&type=template&id=188d0daa"
import script from "./ChannelAdd.vue?vue&type=script&lang=js"
export * from "./ChannelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports